import PropTypes from "prop-types";
import React, {
	Component
}from "react";
import {
	TouchableOpacity,
	View,
	StyleSheet,
} from "react-native";

import InputContainer from "./Layout/InputContainer";
import inputStyle from "./Layout/intputStyle";
import ErrorMessage from "./Layout/ErrorMessage";
import StyledText from "ae-base/Base/StyledText";
import StyledIcon from "ae-base/Base/StyledIcon";

import Style from "@aetonix/styles";

import { useResources, useIdPrefix, useAtaTextSize } from "@aetonix/hooks";

const styles = StyleSheet.create({
	bigger: {
		height: 32,
		width: 32
	},
	biggest: {
		height: 48,
		width: 48
	},
	checkbox: {
		alignItems: "center",
		borderColor: Style.colors.tertiary,
		borderRadius: 55,
		borderWidth: 2,
		height: 24,
		justifyContent: "center",
		marginHorizontal: Style.layout.marginSlim,
		width: 24
	},
	container: {
		alignItems: "center",
		flexDirection: "row",
		justifyContent: "flex-end"
	},
	margin: {
		marginVertical: Style.layout.marginSlim
	},
	marginBigger: {
		marginVertical: Style.layout.marginLarge
	},
	marginBiggest: {
		marginVertical: Style.layout.marginHuge
	},
	textContainer: {
		flexShrink: 1
	},
	touchable: {
		alignSelf: "flex-start"
	}
});

class CheckboxComp extends Component {
	constructor(props){
		super(props);

		this.state = {
			hasChanged: false,
			newValue: false,
		};

		this.handleChange = handleChange.bind(this);
	}

	render(){
		const props = this.props;
		const localize = props.localize;
		const localizeFrom = props.localizeFrom;
		const textsize = props.textsize;
		const contrast = props.contrast;
		const errors = props.errors;
		const schema = props.schema || {};
		const id = props.id;

		const defaultValue = (schema.enum)  ? this.props.defaultValue : !!this.props.defaultValue;
		const newValue = this.state.newValue;

		const hasChanged = this.state.hasChanged;

		const displayValue = hasChanged ? newValue : defaultValue;

		const icon = displayValue ? (
			<StyledIcon name="check" tertiary />
		) : null;

		const containerStyles = [styles.container];
		const checkStyles = [styles.checkbox];

		if(errors && errors.length)
			containerStyles.push(inputStyle.errored);

		const description = schema.description;
		let label;

		let TopContainerComponent = InputContainer;

		let topContainerStyles = [];
		if(props.noInputContainer){
			topContainerStyles = [styles.margin];
			TopContainerComponent = View;
		}

		if(textsize === 1){
			checkStyles.push(styles.bigger);
			topContainerStyles.push(styles.marginBigger);
		} else if (textsize === 2){
			checkStyles.push(styles.biggest);
			topContainerStyles.push(styles.marginBiggest);
		}

		if (schema.localization) {
			label = localizeFrom(schema.localization, ".");
		} else if (schema.description) {
			label = localize(description) || description;
		} else if (props.title){
			label = props.title;
		} else {
			label = "checkbox";
		}

		return (
			<TopContainerComponent style={topContainerStyles}>
				<ErrorMessage id={props.id_prefix + props.id + "_error"} errors={errors} schema={schema} />
				<TouchableOpacity id={props.id_prefix + id} style={styles.touchable} accessible={true} accessibilityComponentType="button" onPress={this.handleChange}>
					<View   accessible={true} style={containerStyles}>
						<View style={checkStyles}>
							{icon}
						</View>
						<View style={styles.textContainer}  accessibilityRole="checkbox" accessibilityLabel={label}>
							<StyledText contrast={contrast} bold={props.bold}>{label}</StyledText>
						</View>
					</View>
				</TouchableOpacity>
			</TopContainerComponent>
		);
	}
}

function handleChange() {
	const hasChanged = this.state.hasChanged;
	const newValue = this.state.newValue;
	const schema = this.props.schema || {};
	const options = schema.enum;

	let defaultValue = this.props.defaultValue;
	defaultValue = (options)  ? this.props.defaultValue : !!this.props.defaultValue;
	const currentValue = hasChanged ? newValue : defaultValue;
	let updateValue = null;
	if (options){
		updateValue = currentValue ? options[0] : options[1];
	}else{
		updateValue = !currentValue;
	}

	const onChange = this.props.onChange;
	if(onChange) onChange(updateValue);

	this.setState({
		newValue: updateValue,
		hasChanged: true,
	});
}

export default function Checkbox(props){
	const textsize = useAtaTextSize();
	const idPrefix = useIdPrefix();
	const { localize, localizeFrom } = useResources();
	return (
		<CheckboxComp {...props} textsize={textsize} localize={localize} localizeFrom={localizeFrom} id_prefix={idPrefix} />
	);
}